<template>
  <v-container>
    <v-row><h1>Configure Rounding</h1></v-row>

    <v-row>
      <v-snackbar v-model="popup.show" timeout=30000>
        {{popup.message}}
        <template v-slot:action="{ attrs }">
          <v-btn
            :color="popup.colour"
            text
            v-bind="attrs"
            @click="popup.show = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-row>

    <v-row>
      <v-col cols="3">
        <v-text-field
          label="Round start to nearest"
          suffix="minutes"
          v-model="settings.start.roundToNearest"
          type="number"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <v-text-field
          label="Round end to nearest"
          suffix="minutes"
          v-model="settings.end.roundToNearest"
          type="number"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-btn value="Submit" @click="save" color="primary">Save</v-btn>

  </v-container>
</template>

<script>
import BusinessService from '../services/BusinessService';
import UserService from '../services/UserService';

export default {
  name: 'RoundingSettings',
  data() {
    return {
      // business: {},
      error: '',
      updated: false,
      dialog: false,
      selectedBusinessId: '',
      user: {},
      userId: this.$auth.user.sub.split('|')[1],
      saving: false,
      popup: {
        show: false,
        message: '',
        colour: 'blue',
      },
      settings: {
        start: {
          roundToNearest: 0,
        },
        end: {
          roundToNearest: 0,
        },
      },
    };
  },
  async created() {
    const token = await this.$auth.getTokenSilently();
    this.user = await UserService.getUser(this.userId, token);
    const { businessIds } = this.user;
    if (businessIds.length > 0) {
      [this.selectedBusinessId] = businessIds;
      // this.business = await BusinessService.getBusiness(this.selectedBusinessId, token);
      this.getRoundingSettings();
    }
  },
  computed: {
  },
  methods: {
    async getRoundingSettings() {
      const token = await this.$auth.getTokenSilently();
      BusinessService.getRoundingSettings(this.selectedBusinessId, token)
        .then((settings) => {
          if (settings && settings.start) {
            this.settings = settings;
          }
        })
        .catch(this.reportError);
    },
    // async getBusiness() {
    //   const token = await this.$auth.getTokenSilently();
    //   BusinessService.getBusiness(this.selectedBusinessId, token)
    //     .then((business) => { this.business = business; })
    //     .catch(this.reportError);
    // },
    async save() {
      const token = await this.$auth.getTokenSilently();
      BusinessService.saveRoundingSettings(this.selectedBusinessId, token, this.settings)
        .then(() => {
          this.reportUpdate();
        })
        .catch((err) => {
          if (err.message) {
            this.reportError(`Couldn't update business: ${err.message}`);
          } else {
            this.reportError("Couldn't update business");
          }
        });
    },
    reportUpdate(message) {
      this.popup.show = true;
      this.popup.message = message || 'Settings Updated';
      this.popup.colour = 'blue';
    },
    reportError(err) {
      this.popup.show = true;
      this.popup.colour = 'red';
      if (err.message) {
        this.popup.message = err.message;
      } else {
        this.popup.message = err;
      }
    },
  },
};
</script>

<style scoped>
div.container {
  /* max-width: 800px; */
  padding: 10px;
  margin: 0 auto;
}

p.error {
  border: 1px solid #ff5b5f;
  background-color: #ffc5c1;
  padding: 10px;
  margin-bottom: 15px;
}

</style>
